import { $authHost } from ".";

class UserApi {
  async getUserInfo(signal) {
    const { data } = await $authHost.get("/users/user", {
      signal,
    });
    return data;
  }

  async logout(signal) {
    const { data } = await $authHost.delete("/sessions/session", {
      signal,
    });
    return data;
  }
}

const userApi = new UserApi();
export default userApi;
